import React from 'react';

const Progress = ({ step, businessEntity }) => {
  return (
    <div>
      {step === 2 && (
        <img
          src={`https://s3-ap-southeast-1.amazonaws.com/backoffice.mokapos.com/images/step-${businessEntity}-1.svg`}
          alt="step 1"
        />
      )}
      {step === 3 && (
        <img
          src={`https://s3-ap-southeast-1.amazonaws.com/backoffice.mokapos.com/images/step-${businessEntity}-2.svg`}
          alt="step 2"
        />
      )}
      {step === 4 && (
        <img
          src={`https://s3-ap-southeast-1.amazonaws.com/backoffice.mokapos.com/images/step-${businessEntity}-3.svg`}
          alt="step 3"
        />
      )}
    </div>
  );
};

export default Progress;
